import * as API from './index'

export default {
    get: params => {
        return API.GET('/api/CompetitionGroup/Get', params)
    },
    edit: params => {
        return API.POST('/api/CompetitionGroup/Edit', params)
    },
    delete: params => {
        return API.DELETE('/api/CompetitionGroup/delete', params)
    },
    import: params => {
        return API.POSTFORM('/api/CompetitionGroup/Import', params)
    },
    download: params => {
        return API.GETBlog('/api/CompetitionGroup/Export', params)
    }, 
        downloadExport: params => {
        return API.GETBlog('/api/CompetitionGroup/ExportOut', params)
    }, 
    getList: params => {
        return API.GET('/api/CompetitionGroup/List', params)
    },
    select: params => {
        return API.GET('/api/CompetitionGroup/select', params)
    },    selectInput: params => {
        return API.GET('/api/CompetitionGroup/selectInput', params)
    },
    selectType: params => {
        return API.GET('/api/CompetitionGroup/SelectType', params)
    },
    selectEntryFee: params => {
        return API.GET('/api/CompetitionGroup/SelectEntryFee', params)
    },
    changeSequence: params => {
        return API.POST('/api/CompetitionGroup/ChangeSequence', params)
    }, editBatch: params => {
        return API.POST('/api/CompetitionGroup/editBatch', params)
    }, selectByMatch: params => {
        return API.GET('/api/CompetitionGroup/SelectByMatch', params)
    }
}


// WEBPACK FOOTER //
// ./src/apis/group.js